export default __webpack_public_path__ + "static/media/bewkoof.db2f9459.PNG";